import { render, staticRenderFns } from "./ym-seedling-records.vue?vue&type=template&id=52448928&scoped=true&"
import script from "./ym-seedling-records.vue?vue&type=script&lang=js&"
export * from "./ym-seedling-records.vue?vue&type=script&lang=js&"
import style0 from "./ym-seedling-records.vue?vue&type=style&index=0&id=52448928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52448928",
  null
  
)

export default component.exports